"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootReducer = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _reduxPersist = require("redux-persist");
var _storage = _interopRequireDefault(require("redux-persist/lib/storage"));
var _config = require("./config");
var _translations = require("./translations");
var _rcPreferences = require("./rcPreferences");
var _apiKeys = require("./apiKeys");
var _auth = require("./auth");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const rootReducer = exports.rootReducer = (0, _toolkit.combineReducers)({
  [_apiKeys.apiKeysSlice.name]: _apiKeys.apiKeysSlice.reducer,
  [_config.configSlice.name]: _config.configSlice.reducer,
  [_translations.translationsSlice.name]: _translations.translationsSlice.reducer,
  [_rcPreferences.rcPreferencesSlice.name]: _rcPreferences.rcPreferencesSlice.reducer,
  auth: (0, _reduxPersist.persistReducer)({
    key: _auth.authSlice.name,
    storage: _storage.default,
    whitelist: ['accessToken', 'refreshToken']
  }, _auth.authSlice.reducer)
});